import { redirect } from "react-router-dom";
import { Breadcrumb } from "../../components/Breadcrumb";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { MergeVendorPage } from "./MergeVendorPage";

// Admin-only: merging vendors moves cross-vendor financial history.
const mergeVendorAuthGate = async () => {
  const user = userStore.getState().user;
  if (!user) return redirect("/login");
  if (user.role_id !== 1) return redirect("/");
  return null;
};

export const mergeVendorRouter = {
  path: "/merge-vendor",
  id: "merge-vendor",
  element: <MergeVendorPage />,
  loader: requireAuth(undefined, mergeVendorAuthGate),
  handle: {
    crumb: () => <Breadcrumb name="Merge Vendor" href="/merge-vendor" />,
  },
};
